
import styled from "styled-components"
import lock from "../assets/images/Lock.svg"
import { levelcolors } from "../constants"

// const StyledGreenCard = styled.div`
//     background-color: rgba(183, 227, 56, 0.3);
//     border-radius: 10px;
//     display: flex;
//     justify-content: ${props => props.noresults ? "center" : "space-around"};
//     align-items: center;
//     flex-direction: column;
//     padding: 40px 0;
//     height: 160px;
// `;
const StyledGreenCard = styled.div`
 background-color: white;
    border: solid;
    border-radius: 10px;
    display: flex;
    justify-content: ${props => props.noresults ? "center" : "space-around"};
    align-items: center;
    flex-direction: column;
    padding: 40px 0;
    height: 160px;
    border: 3px solid #EEEEEE;
`;
const StyledWrapper = styled.div`
   padding: 10px;
`;
export function GameCard({ children, date, gameNumber, score, noresults, blocked, levelno }) {
    return (
        <StyledWrapper className="game-results-grid-card">

            <StyledGreenCard noresults={noresults}>
                {blocked ? <img src={lock} width="50" />
                    :
                    <>
                        <div>Game {gameNumber}</div>
                        {noresults ?
                            <div className="color-text-grey">No results</div>
                            :
                            <>
                                <div>
                                    <span className="color-orange" style={{ fontSize: 40, color: levelcolors[levelno - 1].bgColor }}>{score}</span>
                                    <span style={{ fontSize: 30, color: levelcolors[levelno - 1].color }}>/6</span>
                                </div>
                                <div className="text-center color-text-grey">
                                    {/* <span className="color-text-grey" style={{ fontSize: 12 }}>Date • </span> */}
                                    <span>{date}</span>
                                </div>
                            </>
                        }
                    </>
                }

            </StyledGreenCard>

        </StyledWrapper>
    );
}